import React, { useState, useRef, useEffect } from "react";

import * as FaIcons from 'react-icons/fa';
import { FcServices } from 'react-icons/fc';
import { AiFillFolderOpen } from 'react-icons/ai';
import { ImFloppyDisk, ImCancelCircle, ImPlus } from "react-icons/im";


import { withRouter } from 'react-router';
import { Redirect } from "react-router-dom";
import jwt_decode from 'jwt-decode';
import Pagination from "@material-ui/lab/Pagination";
import AuthService from "../../services/auth.service";
import StockService from "../../services/stock.service";
import ProductsService from "../../services/products.service";
import SelectOptionService from "../../services/select-options.service";
import { format } from 'date-fns';
import { List } from "@material-ui/core";
import MemberService from "../../services/members.service";




const currentUser = AuthService.getCurrentUser();

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const StockInNew = withRouter((props) => {


  if (JSON.parse(localStorage.getItem("user")) == null) {

    return <Redirect to="/login" />;

  }

  let decodedToken = jwt_decode(currentUser.accessToken);
  let currentDate = new Date();
  // JWT exp is in seconds redirect to login
  if (decodedToken.exp * 1000 < currentDate.getTime()) {

    return <Redirect to="/login" />;

  }

  if (!currentUser.roles.includes("ROLE_STOCK")) {
    return <Redirect to="/unauthorized" />;

}

  /***************************************************************************************/
  /***************************************************************************************/
  /***************************************************************************************/
  /***************************************************************************************/
  /***************************************************************************************/
  /***************************************************************************************/

  const initialDataState = {
    id: null,
    stand: "",
    date1: "",
    pid: "",
    product: "",
    qty_in: "",
    stockkeeper: "",
    code: "",
    size: "",
    color: "",
    qty_out: "",
    qty_transfer_in: "",
    qty_transfer_out: "",
    qty_damage: "",
    stand_destination: "",
    stand_source: "",
    description: "",
    comment: "",
    transfer_type: "",
    stock_type: "",
    username: "",
    stockEntryId: "",
    location: "",

    price_value: "",

  };



  const [tutorial, setData] = useState(initialDataState);
  const [submitted, setSubmitted] = useState(false);
  const [currentData, setcurrentData] = useState(initialDataState);
  const [message, setMessage] = useState("");
  const [stockEntryId, setStockEntryId] = useState("");

  const [optionCategorySelectedValue, setOptionCategorySelectedValue] = useState("");
  const [optionCategoryArray, setOptionCategoryArray] = useState([]);

  const [optionCategorySelectedValueTransfer, setOptionCategorySelectedValueTransfer] = useState("");
  const [optionCategorySelectedValueTransferDestination, setOptionCategorySelectedValueTransferDestination] = useState("");
  const [optionCategorySelectedValueTransferSource, setOptionCategorySelectedValueTransferSource] = useState("");
  const [optionCategoryArrayTransfer, setOptionCategoryArrayTransfer] = useState([]);

  const [memberdetails, setMemberDetails] = useState([]);

  const handleChangeoptionCategories = (event) => {
    setOptionCategorySelectedValue(event.target.value);

  }



  const handleInputChange = event => {
    const { name, value } = event.target;
    setData({ ...tutorial, [name]: value });
  };

  const handleInputChangeEdit = event => {
    const { name, value } = event.target;
    setcurrentData({ ...currentData, [name]: value });
  };

  const saveData = () => {

    setPage(1);

    var data = {
      //stand: optionCategorySelectedValue,
      stand: optionCategorySelectedValue,
      date1: format(new Date(), 'yyyy-MM-dd'),
      pid: currentData.id,
      product: currentData.name,
      qty_in: tutorial.qty_in,
      stockkeeper: currentUser.username,
      code: currentData.code,
      size: currentData.size,
      qty_out: tutorial.qty_out,
      qty_transfer_in: tutorial.qty_transfer_in,
      qty_transfer_out: tutorial.qty_transfer_out,
      qty_damage: tutorial.qty_damage,
      stand_destination: optionCategorySelectedValueTransferDestination,
      stand_source: optionCategorySelectedValueTransferSource,
      description: currentData.description,
      comment: tutorial.comment,
      transfer_type: optionCategorySelectedValueTransfer,
      color: currentData.color,
      stock_type: "IN",
      stockEntryId: stockEntryId,
      location:memberdetails.account,
      price_value:tutorial.price_value,
    };


    if (data.product == null || data.product == "") {
      setMessage("Product details are missing!");
    } else if (data.stand == null || data.stand == "" || data.stand == "Select") {
      setMessage("Select valid stock or stand!");
    }else if(data.qty_in == null || data.qty_in==""){
      setMessage("Invalid qty!");

    }else if(data.price_value == null || data.price_value==""){
      setMessage("Price value missing!");
    }else if(!currentUser.roles.includes("ROLE_MAIN_STOCK") && data.stand==="MAIN STOCK"){

      setMessage("Stock not allowed!");

    }
    else {

      StockService.create(data)
        .then(response => {
          setData({
            stand: response.data.stand,
            date1: response.data.date1,
            pid: response.data.pid,
            product: response.data.product,
            qty_in: response.data.qty_in,
            stockkeeper: response.data.stockkeeper,
            code: response.data.code,
            size: response.data.size,
            qty_out: response.data.qty_out,
            qty_transfer_in: response.data.qty_transfer_in,
            qty_transfer_out: response.data.qty_transfer_out,
            qty_damage: response.data.qty_damage,
            stand_destination: response.data.stand_destination,
            stand_source: response.data.stand_source,
            description: response.data.description,
            comment: response.data.comment,
            transfer_type: response.data.transfer_type,
            color: response.data.color,
            price_value:data.price_value,

          });
          setSubmitted(true);
          setMessage("Data saved successfully.");
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });

    }


  };

  const newData = () => {
    setPage(1);
    setData(initialDataState);

    setSubmitted(false);
    setMessage("");
  };

  const [tutorials, setDatas] = useState([]);
  const [searchTitle, setSearchTitle] = useState("");
  const tutorialsRef = useRef();



  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(100);



  const pageSizes = [100, 500, 1000];

  tutorialsRef.current = tutorials;

  const onChangeSearchTitle = (e) => {
    const searchTitle = e.target.value;
    setSearchTitle(searchTitle);
  };





  const getRequestParams = (searchTitle, page, pageSize) => {
    let params = {};

    if (searchTitle) {
      params["code"] = searchTitle;
    }

    if (page) {
      params["page"] = page - 1;
    }

    if (pageSize) {
      params["size"] = pageSize;
    }

    return params;
  };

  const retrieveData = () => {
    setPage(1);

    
    const params = getRequestParams(searchTitle, page, pageSize);

    ProductsService.getAll(params)
      .then((response) => {
        const { tutorials, totalPages } = response.data;

        setDatas(tutorials);


        // console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });

    getSelectOption();
    getSelectOptionTransfer();
    getStockEntryId();
    getMemberData();
  };

  const getMemberData=()=>{
    setPage(1);

    MemberService.getMemberdetails(currentUser.username)
    .then((response) => {
    
        setMemberDetails(response.data);
         
        
    })
    .catch((e) => {
        console.log(e);
    });

}

  const getSelectOption = () => {
    setPage(1);
    var category = "stock-name";
    SelectOptionService.getAllSelectedOptions(category)
      .then((response) => {

        setOptionCategoryArray(response.data);
        // setOptionCategoryArrayTransfer(response.data);



      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getSelectOptionTransfer = () => {
    setPage(1);
    var category = "Stock-transfer-type";
    SelectOptionService.getAllSelectedOptionsTransferType(category)
      .then((response) => {


        setOptionCategoryArrayTransfer(response.data);



      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getStockEntryId = () => {
    setPage(1);

    StockService.getStockEntryCode()
      .then((response) => {

        setStockEntryId(response.data);

      })
      .catch((e) => {
        console.log(e);
      });

  }

  useEffect(retrieveData, [page, pageSize]);

  const refreshList = () => {
    setPage(1);
    retrieveData();
  };



  const findByTitle = () => {
    setPage(1);
    retrieveData();
  };

  const openObject = (id) => {
    setPage(1);
    setcurrentData(initialDataState);

    ProductsService.get(id)
      .then(response => {
        setcurrentData(response.data);

        //console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });

    // props.history.push("/stock/" + id);
  };

  const updateData = () => {
    setPage(1);
    StockService.update(currentData.id, currentData)
      .then(response => {
        //console.log(response.data);
        setMessage("The Data was updated successfully!");
      })
      .catch(e => {
        console.log(e);
      });

  };

  const deleteData = (rowIndex) => {
    setPage(1);
    const id = tutorialsRef.current[rowIndex].id;

    StockService.remove(id)
      .then((response) => {
        /// props.history.push("/product");

        let newDatas = [...tutorialsRef.current];
        newDatas.splice(rowIndex, 1);

        setDatas(newDatas);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };


  const stockOut = () => {
    props.history.push("/stock-out");
  }

  const add = () => {
    props.history.push("/stock-in-new");
  }

  const list = () => {
    props.history.push("/stock-in");
  }

  const stockLevel = () => {
    props.history.push("/stock-level");
  }

  const returned=()=>{
    props.history.push("/stock-returned");
  }



  return (
    <div className='pages'>

      <div className="row">



        {/* cards  */}

        <div className="col-md-3 tool-box">

          <table className="table-tools">
          <div className="table-account">
            <tbody>
            <tr>
              <td rowSpan="3"><h2> <span className="table-tools-img"><FaIcons.FaIdCardAlt /></span> </h2></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><div className="table-name">{memberdetails.firstname}</div></td>
              <td><div className="table-name">{memberdetails.lastname}</div></td>
            </tr>
            <tr>
              <td><div className="table-name">{memberdetails.account}</div></td>
              <td></td>
            </tr>
            <tr>
              <td colSpan="2"> <input onChange={onChangeSearchTitle} id="search" type="text" name="search" placeholder="Product code" className="search-input" />  </td>
              <td><button onClick={findByTitle} className="button-tools"> <span className="table-tools-img-search"><FaIcons.FaSearch /></span>Search</button></td>
            </tr>
            </tbody>
            </div>
          </table>


        </div>
        <div className="col-md-3 tool-box">
          <table>
          <tbody>
            <tr>
              <td><span className="page-title-img"><FaIcons.FaWarehouse /> </span></td>
              <td><span className="page-title"> STOCK SUPPY</span></td>
            </tr>
            </tbody>
          </table>

        </div>

        <div className="col-md-3 tool-box">

          <table className="table-tools">
          <tbody>
          <tr>
              <td className="tg-0lax"><button onClick={refreshList} className="button-tools">Refresh</button></td>
              <td className="tg-0lax"><button onClick={add} className="button-tools">New</button></td>
              <td className="tg-0lax"><button onClick={returned} className="button-tools">Return</button></td>
            </tr>
            <tr>
              <td className="tg-0lax"><button onClick={stockLevel}  className="button-tools">Actual</button></td>
              <td className="tg-0lax"><button onClick={stockOut} className="button-tools">Out</button></td>
            </tr>
            </tbody>

          </table>
        </div>


        {/* end card box */}



        <div className="dataRow-with-two-column">


          <div className="details">

            <div className="table-wrap">
              <table className="table">
                <thead className="scroll-thead">
                  
                  <tr>

                    <th>ID</th>
                    <th>CODE</th>
                    <th>NAME</th>
                    <th>COLOR</th>
                    <th>DESCRIPTION</th>
                    <th>Action</th>


                  </tr>
                </thead>
                <tbody>
                  {tutorials &&
                    tutorials.map((tutorial, index) => (

                      <tr key={tutorial.id}>
                        <td>{tutorial.id}</td>
                        <td>{tutorial.code}</td>
                        <td>{tutorial.name}</td>
                        <td>{tutorial.color}</td>
                        <td>{tutorial.description}</td>
                        <td><div className="table-action-button">

                        <button
                                                        type="button" className="col-md-1 table-buttons"
                                                        onClick={() => openObject(tutorial.id)}
                                                    > <AiFillFolderOpen/>
                                                    </button>

                        </div></td>
                      </tr>

                    ))}
                </tbody>
                <tfoot>
                
              </tfoot>

              </table>
              
            </div>


          </div>

          <div className="details">
            <form className="form form-horizontal ">
              <div className="form-body">
                <div className="row">
                  
                  <div className="col-md-4">
                    <label>PRODUCT</label>
                  </div>
                  <div className="col-md-8 form-group">
                    <input readOnly="readonly" type="text" id="product" className="form-control" name="product" placeholder="Item name" onChange={handleInputChange} validations={[required]} value={currentData.name} />
                  </div>

                  <div className="col-md-4">
                    <label>CODE</label>
                  </div>
                  <div className="col-md-8 form-group">
                    <input readOnly="readonly" type="text" id="code" className="form-control" name="code" placeholder="Code" onChange={handleInputChange}  value={currentData.code} />
                  </div>

                  <div className="col-md-4">
                    <label>SIZE</label>
                  </div>
                  <div className="col-md-8 form-group">
                    <input readOnly="readonly" type="text" id="size" className="form-control" name="size" placeholder="Size" onChange={handleInputChange}  value={currentData.size} />
                  </div>

                  <div className="col-md-4">
                    <label>COLOR</label>
                  </div>
                  <div className="col-md-8 form-group">
                    <input readOnly="readonly" type="text" id="color" className="form-control" name="color" placeholder="Color" onChange={handleInputChange}  value={currentData.color} />
                  </div>

                  <div className="col-md-4">
                    <label>DESCRIPTION</label>
                  </div>
                  <div className="col-md-8 form-group">
                    <input type="text" disabled id="description" className="form-control" name="description" placeholder="Description" onChange={handleInputChange}  value={currentData.description} />
                  </div>


                  <div className="col-md-4">
                    <label>STOCK</label>
                  </div>
                  <div className="col-md-8 form-group">
                  <select className="form-control" onChange={handleChangeoptionCategories} >
                        <option>Select</option>
                        {optionCategoryArray.map((optionCategory) => (
                          <option key={optionCategory.value}>{optionCategory.value}</option>
                        ))}

                      </select>
                  </div>

                  <div className="col-md-4">
                    <label>QTY</label>
                  </div>
                  <div className="col-md-8 form-group">
                    <input type="number" id="qty_in" className="form-control" name="qty_in" placeholder="QTY IN" onChange={handleInputChange}  value={tutorial.qty_in} />
                  </div>

                  <div className="col-md-4">
                    <label>PRICE VALUE</label>
                  </div>
                  <div className="col-md-8 form-group">
                    <input type="number" id="price_value" className="form-control" name="price_value" placeholder="Price value" onChange={handleInputChange}  value={tutorial.price_value} />
                  </div>

                  

                  <div className="col-md-4">
                    <label>COMMENT</label>
                  </div>
                  <div className="col-md-8 form-group">
                    <input type="text" id="comment" className="form-control" name="comment" placeholder="Comment" onChange={handleInputChange}  value={tutorial.comment} />
                  </div>

                  <div className="col-md-4">
                    <label> </label>
                  </div>

                  <label className="col-md-8 danger-message">{message}</label>

                  <div className="col-md-4">
                    <label> </label>
                  </div>




                  <div className="col-md-8 form-group">


                    {submitted ? (<button onClick={newData}
                      className="button-form"><ImPlus /> Add</button>) : (<button  onClick={saveData}
                        type="button" className="button-tools-red"><ImFloppyDisk /> Save </button>)}

                    <button
                      type="button" onClick={list} className="button-form"><ImCancelCircle /> Close</button>


                  </div>





                </div>
              </div>
            </form>

          </div>

        </div>
      </div>

    </div>
  );
});

export default StockInNew;
